import React from "react";
import { Outlet, useParams } from "react-router-dom";
import ExecutorNavigation from "./ExecutorNavigation";
import Header from "./Header";

const ExecutorPlanningLayout: React.FC = () => {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <div data-tour="executor-dashboard-screen" className="min-h-screen bg-stone-50">
      <Header />
      <ExecutorNavigation estateId={estateId ?? ""}>
        <Outlet />
      </ExecutorNavigation>
    </div>
  );
};

export default ExecutorPlanningLayout;